import React from 'react'
import { 
    ArtefactsContainer, 
    ArtefactCard,
    ArtefactWrapper,
    ArtefactsHeading,
    ArtefactsHeading1,
    Title, 
    Desc, 
    ArtefactInfo,
    ArtefactImg
} from './BidayuhArtefacts';

import '../../../../App.css';
import {useState} from 'react'; 
import {GrTools} from 'react-icons/gr';
import {SiSnapcraft} from 'react-icons/si';
import {GiMusicalKeyboard} from 'react-icons/gi';
import {MdMore} from 'react-icons/md';
import {AiOutlineSearch} from 'react-icons/ai';
import { UluAgriList, UluHandiList, UluMusicList, UluOthersList} from './data';


const UluArtefacts = (props)=> {

    const [searchTerm, setSearchTerm] = useState ("");

    return (
            <ArtefactsContainer> 
            
                <ArtefactsHeading> Orang Ulu Artefacts </ArtefactsHeading>
                        <label className = "label"> <AiOutlineSearch/> Filter Arterfect </label>
                        <input className = "searchbox"
                            type = "text"
                            placeholder= " Unwrap your heritage " 
                            onChange = {(event) => {
                                setSearchTerm(event.target.value);
                            }}
                        />
                   
                    <ArtefactsHeading1> 
                        <GrTools/> Agricultural Tools 
                    </ArtefactsHeading1>

                    <ArtefactWrapper> 
                        {UluAgriList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
                    <ArtefactsHeading1> 
                        <SiSnapcraft/> Handicraft 
                    </ArtefactsHeading1>
                    <ArtefactWrapper> 
                      {UluHandiList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>

                    <ArtefactsHeading1> 
                        <GiMusicalKeyboard/> Musical Instrument 
                    </ArtefactsHeading1>

                    <ArtefactWrapper> 
                        {UluMusicList.filter ((artefact) => {
                                if (searchTerm == "") {
                                    return artefact
                                } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                    return artefact
                                }
                            }).map((artefact, key) => {
                        return (
                        <ArtefactCard key={key}> 
                            <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                                <ArtefactInfo> 
                                    <Title> {artefact.name} </Title> 
                                    <Desc> {artefact.description} </Desc>
                                </ArtefactInfo>
                        </ArtefactCard>   
                        );
                        })}
                    </ArtefactWrapper>

                    <ArtefactsHeading1> 
                        <MdMore/> Others 
                    </ArtefactsHeading1>

                    <ArtefactWrapper> 
                        {UluOthersList.filter ((artefact) => {
                                if (searchTerm == "") {
                                    return artefact
                                } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                    return artefact
                                }
                            }).map((artefact, key) => {
                        return (
                        <ArtefactCard key={key}> 
                            <ArtefactImg src= {artefact.img_src} alt = {artefact.alt} />
                                <ArtefactInfo> 
                                    <Title> {artefact.name} </Title> 
                                    <Desc> {artefact.description} </Desc>
                                </ArtefactInfo>
                        </ArtefactCard>   
                        );
                        })}
                    </ArtefactWrapper>

            </ArtefactsContainer>
    );
};

export default UluArtefacts
